/**
 * Table name helpers
 * 
 * Tables are in the 'littlebooker' schema.
 * Once the schema is exposed in Supabase PostgREST settings, we can use simple table names.
 */

// Table names (simple names since schema is set in PostgrestClient)
export const TABLES = {
  // Multi-tenancy tables
  accounts: 'accounts',
  account_members: 'account_members',
  users: 'users',
  // Core entity tables
  places: 'places',
  things: 'things',
  people: 'people',
  happenings: 'happenings',
  happening_series: 'happening_series',
  happening_participants: 'happening_participants',
  happening_requirements: 'happening_requirements',
  place_equipment: 'place_equipment',
  tasks: 'tasks',
  task_comments: 'task_comments',
  task_reminders: 'task_reminders',
  completion_reminders: 'completion_reminders',
  happening_reminders: 'happening_reminders',
  // Templates and workflows
  happening_templates: 'happening_templates',
  task_definitions: 'task_definitions',
  participant_submissions: 'participant_submissions',
  // API Keys
  api_keys: 'api_keys',
  // People participants and completion notifications
  people_participants: 'people_participants',
  completion_notification_roles: 'completion_notification_roles',
  pending_completion_notifications: 'pending_completion_notifications',
  // Auth audit logging
  auth_events: 'auth_events',
  // Login sessions (rotating refresh tokens)
  user_sessions: 'user_sessions',
  // Slug history (old slugs that should still resolve)
  slug_aliases: 'slug_aliases',
  // Programs (multi-stage groupings of happenings, e.g. festivals)
  programs: 'programs',
  program_places: 'program_places',
  // Staffing (availability-based assignment of staff to performances)
  staff_roles: 'staff_roles',
  person_roles: 'person_roles',
  staff_availability: 'staff_availability',
  place_role_defaults: 'place_role_defaults',
  place_role_day_defaults: 'place_role_day_defaults',
  happening_role_requirements: 'happening_role_requirements',
  staff_shifts: 'staff_shifts',
  staff_assignments: 'staff_assignments',
  // Collective Selection (structured multi-round staff voting)
  selections: 'selections',
  selection_voters: 'selection_voters',
  selection_recusals: 'selection_recusals',
  selection_rounds: 'selection_rounds',
  selection_ballots: 'selection_ballots',
  selection_ballot_entries: 'selection_ballot_entries',
  selection_individual_picks: 'selection_individual_picks',
  selection_audit_events: 'selection_audit_events',
  listens: 'listens',
  // Generic account-scoped labels on happenings
  tags: 'tags',
  happening_tags: 'happening_tags',
} as const;
